/**
 * Redirecionamento legado de credenciais do domínio antigo do CONADI, hoje
 * migrado pra templo.app.br. Só ativa para esses hostnames específicos —
 * inofensivo pra qualquer outro site. Compartilhado entre o catch-all
 * (PublicEntry, router/index.tsx) e a rota de página/post por slug único
 * (PublicPageView.tsx), já que os dois podem capturar esses paths.
 */
export function getLegacyCredentialRedirect(): string | null {
  const url = new URL(window.location.href);
  const hostname = url.hostname.toLowerCase();
  const isConadiHost = hostname === 'conadi.org' || hostname === 'www.conadi.org';
  if (!isConadiHost) return null;

  if (url.pathname === '/consulta-situacao.php') {
    const cpf = url.searchParams.get('cpf')?.replace(/\D/g, '');
    return cpf ? `https://conadi.templo.app.br/credencial/${encodeURIComponent(cpf)}/` : null;
  }

  const tokenMatch = url.pathname.match(/^\/c\/([A-Za-z0-9_-]+)\/?$/);
  if (tokenMatch) {
    return `https://conadi.templo.app.br/credencial/${encodeURIComponent(tokenMatch[1])}/`;
  }

  return null;
}
